import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './Test2.css';

class DGRTest2 extends Component {
    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
    }
    render(){
        return (
            <div className="test2">
                <div className="test2Box">
                </div>
                <div className="test2Box">
                </div>
                <div className="test2Box">
                </div>
                <div className="test2Box">
                </div>
            </div>
        )
    }
}
DGRTest2 = inject('DGRBackgroundStore')(observer(DGRTest2))     
export default DGRTest2;



// WEBPACK FOOTER //
// ./src/components/DGR/Test2/Test2.js